export default {
    button: {
        approve: 'Approve',
        reject: 'Reject',
        cancel: 'Cancel',
        annul: 'Cancel',
        send: 'Send',
        save: 'Save',
        sameRequest: 'New similar request'
    },
    alert: {
        success: 'Approval successfully submitted',
        error: 'Approval failed'
    },
    approvalProject: {
        headers: {
            general:    'General Information',
            sender:     'Sender',
            timePassed: 'Sent',
            date:       'Sent On',
        },
        approval_type: 'Approval type'
    },
    sort: {
        title: 'Sort',
        position: {
            inc: 'Vacancy name Ascending',
            dec: 'Vacancy name Descending'
        },
        peopleName: {
            inc: 'Lastname name Ascending',
            dec: 'Lastname name Descending'
        },
        projectName: {
            inc: 'Vacancy name Ascending',
            dec: 'Vacancy name Descending'
        },
        date: {
            inc: 'Date Ascending',
            dec: 'Date Descending'
        },
        townName: {
            inc: 'City name Ascending',
            dec: 'City name Descending'
        },
        senderName: {
            inc: 'Sender name Ascending',
            dec: 'Sender name Descending'
        }
    },
};
